export const TREE_ADD = 'TREE_ADD';
export const TREE_REMOVE = 'TREE_REMOVE';
export const TREE_EDIT = 'TREE_EDIT';
export const TREE_UPDATE_ALL = 'TREE_UPDATE_ALL';



export const treeAdd = (item) => {
	return {
		type: TREE_ADD,
		item
	};
};

export const treeRemove = (id) => {
	return {
		type: TREE_REMOVE,
		id
	}
};

export const treeEdit =  (item) => {
	return {
	type: TREE_EDIT,
	item
	};
};

export const treeUpdateAll = (tree) => {
	return {
		type: TREE_UPDATE_ALL,
		tree
	};
};


// WEBPACK FOOTER //
// ./frontend/actions/ActionTree.js